module.exports = __webpack_public_path__ + "static/media/stage-switch.f4a052fb.svg";